import {
  AI_MODEL_CONFIGS,
  AiModelSchema,
  DECISION_MODEL_CONFIGS,
  isDecisionModel,
  type AiModel,
  type TranscriptionModel
} from '@bliks-io/contracts';

export const AI_MODEL_LABELS = Object.fromEntries(
  AiModelSchema.options.map((model) => [model, AI_MODEL_CONFIGS[model].label])
) as Record<AiModel, string>;

export const TRANSCRIPTION_MODEL_LABELS: Record<TranscriptionModel, string> = {
  'gpt-4o-transcribe': 'GPT-4o Transcribe'
};

/** Raw stored model name → display label. Embedding deployments and unknown
 *  names fall back to the raw name. */
export function getAiModelLabel(model: string): string {
  return (
    (AI_MODEL_LABELS as Record<string, string>)[model] ??
    (TRANSCRIPTION_MODEL_LABELS as Record<string, string>)[model] ??
    (isDecisionModel(model) ? DECISION_MODEL_CONFIGS[model].label : model)
  );
}
